import React from 'react'
import { Flex } from '../../../core-components'
import { Tick } from './Tick'
import { Mixed } from './Mixed'
import { Empty } from './Empty'

type Props = {
  isChecked: boolean
  isDisabled: boolean
  isMixedCheck: boolean
}

export const CoreCheckbox = ({ isChecked, isMixedCheck, isDisabled }: Props) => {
  return (
    <Flex
      w={4}
      h={4}
      bg={getBgColor({ isChecked, isDisabled, isMixedCheck })}
      borderRadius={4}
      alignItems='center'
      justifyContent='center'
      flexShrink={0}
    >
      {!isChecked && !isMixedCheck && <Empty isDisabled={isDisabled} />}
      {isChecked && !isMixedCheck && <Tick />}
      {isMixedCheck && <Mixed />}
    </Flex>
  )
}

const getBgColor = ({
  isChecked,
  isDisabled,
  isMixedCheck,
}: {
  isChecked: boolean
  isDisabled: boolean
  isMixedCheck: boolean
}) => {
  if (!isChecked && !isMixedCheck) {
    return undefined
  }
  if (isDisabled) {
    return 'bg/select-item-major-checked-disabled'
  }
  return 'bg/select-item-major-checked'
}
